import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Span } from '@sopranodesign/pulse-components';
import { TemplatingTextInput } from '@sopranodesign/pulse-templating';

const SetLanguageContent = ({ content, onChange }) => {
  const handleLanguageChange = language => {
    onChange({ language });
  };

  return (
    <Flex center fat="true" xSpace>
      <Span>using</Span>
      <Flex col fat>
        <TemplatingTextInput
          aria-label="Language"
          placeholder="English"
          value={content.language}
          onChange={handleLanguageChange}
        />
      </Flex>
    </Flex>
  );
};

SetLanguageContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  content: PropTypes.shape({
    language: PropTypes.string.isRequired
  }).isRequired
};

export default SetLanguageContent;
